import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const excludeScheduleCommentary = api(async function excludeScheduleCommentary({ id, excluded }) {
    return mutate(
        gql`
            mutation ExcludeScheduleCommentary($id: String!, $excluded: Boolean!) {
                excludeScheduleCommentary(id: $id, excluded: $excluded)
            }
        `,
        { id, excluded },
        { returns: "excludeScheduleCommentary" }
    )
})
